(() => {

	const multiple_paths = document.querySelector(".m47b");

	if(multiple_paths !== null && multiple_paths.classList.contains('m47b--dark')) {
		const m47b_buttons = multiple_paths.querySelectorAll(".button");
		m47b_buttons.forEach((button) => {
			button.classList.add('button--white');
		})
	}

})();